<template>
  <form :class="{'nx-active': active}"
        :data-vv-scope="scope"
        :id="'scope-' + scope"
        class="nx-form"
        @submit="onSubmit">
    <h2 class="nx-form-legend mb-1 mt-2" v-html="heading" v-if="heading"></h2>
    <div class="nx-form-fieldset">
      <nx-channel-field
          v-for="fieldConfig in fieldsConfig"
          :key="`channel-field.${fieldConfig.key}`"
          :field="fieldConfig.field"
      >
        <component
            :is="fieldConfig.component"
            :key="`channel.${fieldConfig.key}`"
            :label="fieldConfig.label"
            :name="fieldConfig.name"
            :validation="fieldConfig.validation"
            :value="value[fieldConfig.name]"
            v-bind="fieldConfig.params"
        ></component>
      </nx-channel-field>
    </div>
  </form>
</template>

<script>
import FormScopeGenerator from '@/modules/form/FormScopeGenerator';
import NxChannelField from '@/modules/content/editor/ChannelField';

export default {
  name: 'nx-content-form-channel-scope-generator',
  components: { NxChannelField },
  extends: FormScopeGenerator,
};
</script>
